export default function isUploadcareUrl(url: string) {
  return url.indexOf('https://ucarecdn.com/') === 0
}
